import React, { forwardRef } from "react"
import styled from "styled-components"
import { theme } from "../../theme"
import { Tooltip as MaterialTooltip, TooltipProps } from "@mui/material"

export const TooltipWithRef = forwardRef((props: TooltipProps, ref) => {
  return <MaterialTooltip ref={ref} {...props} />
})

export const Tooltip = styled((props) => <TooltipWithRef classes={{ popper: props.className }} {...props} />)`
  & .MuiTooltip-tooltip {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    border-radius: ${theme.borderRadius};
    background-color: ${theme.color.black3};
    padding: ${theme.spacing.m};
  }
`

export const TooltipWhite = styled((props) => <TooltipWithRef classes={{ popper: props.className }} {...props} />)`
  & .MuiTooltip-tooltip {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    border-radius: ${theme.borderRadius};
    background-color: ${theme.color.white};
    padding: ${theme.spacing.m};
    color: ${theme.color.black1};
  }
`
